import { useTranslation } from 'react-i18next';
import { useProvider } from '../../../hooks/useProvider';
import { Alert, AlertDescription, AlertTitle } from '../../shadcn/Alert';
import { Button } from '../../shadcn/Button';
import { Spinner } from '../../shadcn/Spinner';
import { UniLoginLayout } from './screen-layout';

export type UniLoginProgressStatus = 'permission' | 'login' | 'uploading' | 'backend';

const PROGRESS_KEYS = {
  permission: 'LoginScreen.unilogin.waiting_permission',
  login: 'LoginScreen.unilogin.waiting_login',
  uploading: 'LoginScreen.unilogin.uploading',
  backend: 'LoginScreen.unilogin.backend',
} satisfies Record<UniLoginProgressStatus, string>;

const PROGRESS_TITLE_KEYS = {
  permission: 'LoginScreen.unilogin.waiting_permission.title',
  login: 'LoginScreen.unilogin.waiting_login.title',
  uploading: 'LoginScreen.unilogin.uploading.title',
  backend: 'LoginScreen.unilogin.backend.title',
} satisfies Record<UniLoginProgressStatus, string>;

/** From automatically starting the extension until the account is prepared in Unipile. */
export function UniLoginProgress({
  status,
  backendRetrying,
  onRetry,
}: {
  status: UniLoginProgressStatus;
  backendRetrying: boolean;
  onRetry: () => void;
}) {
  const { t } = useTranslation();
  const { provider_name } = useProvider();

  const retrying = status === 'backend' && backendRetrying;
  const title_key = retrying ? 'LoginScreen.unilogin.backend_retrying.title' : PROGRESS_TITLE_KEYS[status];
  const description_key = retrying ? 'LoginScreen.unilogin.backend_retrying' : PROGRESS_KEYS[status];

  return (
    <UniLoginLayout
      actions={
        status === 'login' ? (
          <Button type="button" onClick={onRetry}>
            {t('LoginScreen.unilogin.signed_in_continue', { ns: 'translation', provider: provider_name })}
          </Button>
        ) : null
      }
    >
      <Alert>
        <Spinner />
        <AlertTitle>{t(title_key, { ns: 'translation' })}</AlertTitle>
        <AlertDescription>{t(description_key, { ns: 'translation', provider: provider_name })}</AlertDescription>
      </Alert>
    </UniLoginLayout>
  );
}
